// extracted by mini-css-extract-plugin
export default {"targetPlatformsContainer":"targetPlatformsContainer__FQk4s"};